import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TimeoutCheckService } from '@app/services/timeout-check.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  title = 'IotUI';

  constructor(private readonly timeoutCheckService: TimeoutCheckService) {}

  ngOnInit(): void {
    this.timeoutCheckService.startTimer();
  }
}
